import React from 'react';
import SiteHeader from 'components/SiteHeader';
import { Link } from 'react-router-dom';

export default function Hakkimizda() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <SiteHeader />
      <div className="h-16 md:h-20"></div>

      <main className="container mx-auto max-w-4xl px-4 py-12 md:py-16">
        
        <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-neutral-900 mb-6 text-center">
          Hakkımızda
        </h1>

        <div className="space-y-8 text-neutral-700 leading-relaxed text-base">
          
          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-3 border-b border-rose-100 pb-2">
              Misyonumuz ve Vizyonumuz
            </h2>
            <p>
              Anora Forever olarak misyonumuz; hayatınızın en özel ve unutulmaz anlarını, tüm misafirlerinizin katkılarıyla eksiksiz bir dijital albümde birleştirmektir. Düğünler, nişanlar, mezuniyetler, kurumsal etkinlikler veya özel kutlamalar... Amacımız, dağınık durumdaki değerli fotoğraf ve video anılarını tek bir platformda toplayarak, organizasyon sahiplerine zahmetsiz ve güvenli bir dijital miras sunmaktır.
            </p>
            <p>
              Vizyonumuz, dijital anı toplama alanında Türkiye’nin en güvenilir ve en pratik platformu olmak, teknoloji ve duygusal değerleri en üst düzeyde buluşturmaktır.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-3 border-b border-rose-100 pb-2 pt-4">
              Anora Forever Farkı
            </h2>
            <p>
              Hizmetimiz, kullanıcı deneyimini ve güvenliği ön planda tutarak geliştirilmiştir. Kalabalık organizasyonlarda dahi, misafirlerinize hiçbir uygulama indirme zorunluluğu getirmeden, sadece bir QR kod veya link aracılığıyla fotoğraf, video ve ses dosyalarını orijinal kalitesinde yükleme imkanı sunuyoruz.
            </p>
            
            <ul className="list-disc list-inside space-y-2 pl-6 mt-4">
              <li>Orijinal Kalite: İçerikler sıkıştırılmadan, yüklendiği orijinal çözünürlükte saklanır.</li>
              <li>Yüksek Güvenlik: Tüm albümler size özel erişim kodları ile korunur ve üçüncü taraflarla paylaşılmaz.</li>
              <li>Kullanım Kolaylığı: Misafirler için sıfır öğrenme eğrisi ve anında yükleme deneyimi.</li>
              <li>Tam Kontrol: Yüklenen tüm içerikler üzerinde tam kontrol ve yönetim hakkı size aittir.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-3 border-b border-rose-100 pb-2 pt-4">
              Kurumsal Bilgiler
            </h2>
            <p className="font-semibold text-neutral-800">
                Resmi unvanımız ve iletişim bilgilerimiz aşağıdadır:
            </p>
            <ul className="list-none space-y-2 pl-4 mt-2 text-sm">
                <li>Ticari Unvan:  ANORA FOREVER YAZILIM VE REKLAM ORGANİZASYON LİMİTED ŞİRKETİ</li>
                <li>Adres: SULTAN SELİM MAH. ESKİ BÜYÜKDERE CAD. NO: 61 İÇ KAPI NO: 2 KAĞITHANE/İSTANBUL</li>
                <li>E-posta: info@anoraforever.com</li>
                <li>Mersis No: 0070123001700001</li>
            </ul>
            <p className="pt-4">
                Tüm yasal metinlerimize <Link to="/gizlilik-politikasi" className="text-rose-600 hover:underline font-medium">Gizlilik Politikası</Link> ve <Link to="/mesafeli-satis-sozlesmesi" className="text-rose-600 hover:underline font-medium">Mesafeli Satış Sözleşmesi</Link> sayfalarımızdan ulaşabilirsiniz.
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}